import React, { useState } from 'react';

import { Trans } from '@lingui/react/macro';

import AIAnalysis from './AIAnalysis';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import VideoRecorder from './VideoRecorder';

interface RecordingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const RecordingModal: React.FC<RecordingModalProps> = ({ isOpen, onClose }) => {
  const [recordingComplete, setRecordingComplete] = useState(false);
  const [videoBlob, setVideoBlob] = useState<Blob | null>(null);
  const [needsCleanup, setNeedsCleanup] = useState(false);

  const handleRecordingComplete = (blob: Blob) => {
    setVideoBlob(blob);
    setRecordingComplete(true);
  };

  const handleCleanup = () => {
    setNeedsCleanup(true);
  };

  const handleCloseModal = () => {
    onClose();
    // Reset state after modal is closed
    setTimeout(() => {
      setRecordingComplete(false);
      setVideoBlob(null);
      if (needsCleanup) {
        window.location.reload();
      }
    }, 300);
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleCloseModal}>
      <DialogContent className="max-w-5xl w-full h-[90vh] p-0 overflow-hidden rounded-xl border shadow-lg">
        <DialogHeader className="px-6 py-4 border-b">
          <DialogTitle>
            {!recordingComplete ? <Trans>Record Your Practice</Trans> : <Trans>Practice Analysis</Trans>}
          </DialogTitle>
        </DialogHeader>
        <div className="relative w-full h-full flex flex-col">
          <div className="flex-1 overflow-auto">
            {!recordingComplete ? (
              <VideoRecorder
                onRecordingComplete={handleRecordingComplete}
                onCleanup={handleCleanup}
              />
            ) : (
              <AIAnalysis videoBlob={videoBlob} isAnalyzing={false} />
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RecordingModal;
